import { BaseModel } from "../base.model";

export class RefStrategicPriority extends BaseModel {
  name: string;
}
